import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { serviceProducts } from '../Data';
import ServiceContent from './ServiceContent';
import "../Style/ServiceContents.scss";
import arrowImg from "../Assets/images/arrow.png"

const ServiceContents = () => {
    return (
        <div className="serviceContents_wrapper">
          <img className='arrowImg' src ={arrowImg} alt="arrowImg"/>
    <Container>
        <Row>
          {serviceProducts.map((product) => (
            <ServiceContent product={product} key={product.id} />
          ))}
        </Row>
        </Container>
    </div>
    );
};

export default ServiceContents;